import React from "react";
import { Box, Typography, Paper, Stack, Button, Chip } from "@mui/material";

interface ManagePlanProps {
  userName: string | null;
  userPlan: "Free" | "Pro" | "Team";
  onPlanChange: (plan: "Free" | "Pro" | "Team") => void;
  onNavigate: (page: string) => void;
}

export default function ManagePlan({
  userName,
  userPlan,
  onPlanChange,
  onNavigate,
}: ManagePlanProps): JSX.Element {
  const plan = userPlan;

  return (
    <Box sx={{ maxWidth: 760, width: "100%", ml: 0, mt: 4 }}>
      <Typography variant="h4" sx={{ fontWeight: 800, mb: 1 }}>
        Manage Plan
      </Typography>
      <Typography variant="body2" sx={{ color: "text.secondary", mb: 3 }}>
        {plan === "Free"
          ? "Choose the plan that fits your writing and research needs. Unlock the full potential of CoWrite AI."
          : "Review your current subscription and manage billing."}
      </Typography>

      <Paper
        elevation={0}
        sx={{
          p: 3,
          borderRadius: 3,
          border: "1px solid",
          borderColor: "divider",
          background: "rgba(255,255,255,0.02)",
        }}
      >
        <Stack spacing={2}>
          <Stack direction="row" spacing={1} alignItems="center">
            <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
              Current plan
            </Typography>
            <Chip
              label={plan}
              color={plan === "Free" ? "default" : "primary"}
              size="small"
            />
          </Stack>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            Signed in as {userName || "guest"}.
          </Typography>

          {plan === "Free" && (
            <Typography
              variant="body2"
              sx={{ color: "text.secondary", fontStyle: "italic" }}
            >
              Upgrade to unlock premium limits, faster processing, team
              collaboration, and dedicated support.
            </Typography>
          )}

          <Stack direction={{ xs: "column", sm: "row" }} spacing={2}>
            {plan === "Free" ? (
              <>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => onNavigate("premium")}
                >
                  Upgrade to Pro
                </Button>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => onNavigate("premium")}
                >
                  View Team Plan
                </Button>
              </>
            ) : (
              <>
                <Button variant="contained" color="primary">
                  Change plan
                </Button>
                <Button variant="outlined" color="primary">
                  Update payment method
                </Button>
                <Button variant="text" color="error">
                  Cancel subscription
                </Button>
              </>
            )}
          </Stack>
        </Stack>
      </Paper>
    </Box>
  );
}
